import { Component, OnInit ,ViewChild} from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import swal from 'sweetalert2';  
import { TreeNode } from "primeng/api";
export interface NewTreeNode extends TreeNode {
  visible?: boolean;
  children?: NewTreeNode[];
}
@Component({
  selector: 'app-lista-ddf',
  templateUrl: './lista-ddf.component.html',
  styleUrls: ['./lista-ddf.component.scss']
})

export class ListaDdfComponent implements OnInit {
  @ViewChild('close_est',null) close_est;  
  @ViewChild('craci',null) craci;
  constructor(
    public authService: AuthService,
    private sanitizer: DomSanitizer,
    public router: Router) { }

  ngOnInit() {
    //this.ls_raci()
    this.ls_puestos()
    this.ls_raci()
  }
  collapseAll(){
    this.options.forEach( node => {
        this.expandRecursive(node, false);
    } );
}
private expandRecursive(node:TreeNode, isExpand:boolean){
  node.expanded = isExpand;
  if (node.children){
      node.children.forEach( childNode => {
          this.expandRecursive(childNode, isExpand);
      } );
  }
}
  
  bndmnugral=true;
  oculta_menu(){
   
    if(this.bndmnugral==true){
      this.bndmnugral=false;
    }else{
      this.bndmnugral=true;
    }
    console.log(this.bndmnugral);
  }
  raci;id_cliente=0;
  raci_list;loading
  org;  
  nodes;
  options;
  ls_puestos(){  
    this.id_cliente=Number(localStorage.getItem("id_cliente"));
    
    this.loading =  true;
    var sqry;
    sqry = " select" +
            " id,idarea1 as id_ant,titulo as nombre," +
            " ( select count(*) from tblencrequisito" +
            "  where tblexperiencia_tl.id = tblencrequisito.idexperiencia" +
            " and estado = 'A'" +
            " ) as total" +
            " from tblexperiencia_tl"+
            " where id_cliente = " + this.id_cliente +
            " and estatus = 'A'";

    this.authService.ejecuta1(sqry)
    .then(
      data  => { 
        this.loading =  false;       
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);      
        if (res.length!=0){
          var _vec = [];
          _vec.push({ 
            id: 0, 
            id_ant: -1, 
            nombre: "Estructura organizacional", 
            total: 0
          });    
          for(var i = 0; i < res.length;i++){
            _vec.push({ 
              id: res[i].id, 
              id_ant: res[i].id_ant, 
              nombre: res[i].nombre, 
              total: res[i].total,
            });                         
          }
          this.org = _vec

          for(let i=0;i<this.org.length;i++){
            if(this.org[i].id==0){

              this.nodes=[{
                label: this.org[i].nombre,
                total: this.org[i].total,
                data: this.org[i].id,
                dataA: this.org[i].id_ant,
                children:this.get_nodes(this.org[i].id)
                }];
            }
          }

          this.options = this.nodes ;
          this.options = this.getValidTreeNodeItems(this.options);

        }
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }
  getValidTreeNodeItems(treeNodes: NewTreeNode[]): NewTreeNode[] {
    const validItem = treeNodes.filter(i => i.visible !== false);

    validItem.forEach(i => {
      if (i.children) {
        i.children = this.getValidTreeNodeItems(i.children);
      }
    });
    return validItem;
  }
  get_nodes(id){
    var child:any=[];
    for(var x=0;x<this.org.length;x++){
      if (this.org[x].id_ant==id){
        child.push({
          label: this.org[x].nombre,
          total: this.org[x].total,
          data: this.org[x].id,
          dataA: this.org[x].id_ant,          
          children:this.get_nodes(this.org[x].id)
        });
      }
    }
    return child;
  }
  node_sel(n){

    if(n.data==0)return;
    this.estructura.id=n.data;
    this.estructura.nombre=n.label;
    this.collapseAll();
    this.raci_list=[];
    console.log(n.data)
    for(var i=0;i<this.raci.length;i++){
      if(this.raci[i].id_org==n.data){
        console.log("es correcto")
        this.raci_list.push(this.raci[i]);
      }
    }
    this.close_est.nativeElement.click();
    console.log(this.raci_list)
    //alert(n.data)
  }
  estructura={
    id:0,
    nombre:""
  }
  raci_id=0;
  n_raci(){
    this.raci_
    this.bndv_raci=true;
    this.raci_="";
    this.descripcion_raci=""
    this.objetivo_raci=""
  }
  selectedFile: TreeNode;
  upd_raci(){
    let postData = {
      id:this.raci_id,
      raci:this.raci_,
      sufijo:this.sufijo,    
      descripcion:this.descripcion_raci,
      objetivo:this.objetivo_raci,
      org_id:this.org_id2
    }
    //console.log(postData)
    this.authService.service("/api/upd_raci",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);     
        for(var i=0;i<this.raci.length;i++){
          if(this.raci[i].id==this.raci_id){
            this.raci[i].descipcion=this.raci_;
            this.raci[i].procedimiento=this.descripcion_raci;
            this.raci[i].objetivo=this.objetivo_raci;
          }
        }
        for(var i=0;i<this.raci_list.length;i++){
          if(this.raci_list[i].id==this.raci_id){
            this.raci_list[i].descipcion=this.raci_;
            this.raci_list[i].procedimiento=this.descripcion_raci;
            this.raci_list[i].objetivo=this.objetivo_raci;
          }
        }
        this.craci.nativeElement.click();
  
        swal.fire('¡Ok!', '', 'success');
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });  
  }
  org_id2=0;
  descripcion_raci="";
  objetivo_raci=""
  ddf_e(itm){
    this.bndv_raci=false
    this.raci_id=itm.id
    this.raci_=itm.descipcion
    this.sufijo=itm.sufijo
    this.descripcion_raci=itm.descripcion_raci
    this.objetivo_raci=itm.objetivo
    this.org_id2=itm.org_id
  }
  del_ddf(itm){
    if(confirm("Confirm to delete this record?")==false)return;
    let postData = {
      id:itm.id
    }
    console.log("del_raci");
    console.log(postData);
    this.authService.service("/api/del_raci",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        var aux_=[] 
        for(var i=0;i<this.raci_list.length;i++){
          if(this.raci_list[i].id!=itm.id){
            aux_.push(this.raci_list[i])
          }
        }
        this.raci_list=aux_;
        var aux_=[] 
        for(var i=0;i<this.raci.length;i++){
          if(this.raci[i].id!=itm.id){
            aux_.push(this.raci[i])
          }
        }
        this.raci=aux_;
        this.ls_raci();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });   
  }
  gda_raci(){
    let postData = {
      id_cliente:this.id_cliente,
      raci:this.raci_,
      sufijo:this.sufijo,
      org_id:this.estructura.id,
      descripcion:this.descripcion_raci,
      objetivo:this.objetivo_raci
    }
    this.authService.service("/api/gda_raci",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);     
        var r={
          descipcion:this.descripcion_raci,
          estatus: "A",
          id: res.insertId,
          id_cliente: this.id_cliente,
          id_org: this.estructura.id,
          idx: 0,
          objetivo: "",
          procedimiento: "",
          sufijo: "",
          tipo: "R",

        }
        this.raci.push(r)
        //this.raci_list.push(r)
        this.raci_list = this.raci;

        this.craci.nativeElement.click();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });  
  }
  ddf(id){
    this.router.navigate([]).then(result => {   window.open('https://hoshinup.garocedev.com/ddf/?'+id.toString(), '_blank'); }); 
  }
  bndv_raci=true;
  raci_="";
  sufijo="";

   ls_raci(){
    let postData = {
    id_cliente:Number(localStorage.getItem("id_cliente"))}
    console.log(postData);
    this.authService.service("/api/get_raci",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);             
        console.log(res);
        this.raci=res;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
          this.loading=false;
      });  
      this.loading=false;

  }
}
